module.exports = __webpack_public_path__ + "static/media/card_2x.d1b0f755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/philadelphia/card_2x.jpg
// module id = 892
// module chunks = 27